module.exports = __webpack_public_path__ + "static/media/yzx.d7a2f103.png";